import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.675 18.906a9.63 9.63 0 0 1-6.862-2.813A9.63 9.63 0 0 1 0 9.23q0-3.1 1.763-5.6A9.56 9.56 0 0 1 6.4.081a.94.94 0 0 1 .94.102q.435.304.41.797-.05 2.1.675 3.987a9.8 9.8 0 0 0 2.2 3.388A9.4 9.4 0 0 0 14 10.505c1.271.468 2.622.68 3.975.625q.55-.025.85.35.3.376.125.875a9.63 9.63 0 0 1-3.6 4.75 9.6 9.6 0 0 1-5.675 1.8m.01-1.8q2.19 0 4.046-1.114a7.93 7.93 0 0 0 2.92-3.062 12.8 12.8 0 0 1-3.976-1.011 10.9 10.9 0 0 1-3.35-2.314q-1.5-1.5-2.343-3.377a11.9 11.9 0 0 1-1.007-3.973 7.94 7.94 0 0 0-3.05 2.912A7.7 7.7 0 0 0 1.8 9.22q0 3.36 2.263 5.624 2.261 2.262 5.622 2.262"
    }, null, -1)
  ]))]))
}
export default { render: render }